import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import WorkingProcess from "../Section/WorkingProcess";
import { FaUserMd } from "react-icons/fa";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import Spacing from "../Spacing";
import Post from "../Post";
import { Helmet } from "react-helmet";
const workingProcessData = [
  {
    title: "Egg Making (Ovalation Inductim)",
    subTitle:
      "Specific medications are given to stimulate the growth of healthy eggs, improving the chances of successful fertilization.",
    iconUrl: "/images/home_2/iui.png",
    number: "01",
  },
  {
    title: "Egg Tracking (Monitoring Ovulation)",
    subTitle:
      "The woman undergoes regular transvaginal ultrasounds to track egg development. When the egg is mature, a trigger injection is administered to induce ovulation.",
    iconUrl: "/images/home_2/department_icon30.png",
    number: "02",
  },
  {
    title: "Semen Preparation",
    subTitle:
      "The IUI is scheduled 24 to 40 hours after the trigger injection. A semen sample is collected and processed to concentrate the healthiest sperm for the procedure.",
    iconUrl: "/images/home_2/departmentLap4.png",
    number: "03",
  },
  {
    title: "Insemination",
    subTitle:
      "The prepared sperm is inserted directly into the uterus during ovulation using a thin catheter. This quick procedure aims to increase the likelihood of fertilization. Success rates can be up to 20% per cycle, with potential risks including multiple pregnancies and infection.",
    iconUrl: "/images/home_2/department_icon3.png",
    number: "04",
  },
  {
    title: "Pregnancy Test",
    subTitle:
      "A pregnancy test is conducted about two weeks after the insemination to determine if the procedure was successful.",
    iconUrl: "/images/home_2/department_icon9.png",
    number: "05",
  },
];
const faqData = [
  {
    title: "What is IUI (Intra Uterine Insemination) ?",
    content:
      "IUI, or Intra Uterine Insemination, is a fertility treatment that involves placing washed and concentrated sperm directly into a woman's uterus around the time of ovulation. This procedure increases the number of sperm that reach the fallopian tubes, thereby enhancing the chances of fertilization.",
  },
  {
    title: "Who is a good candidate for IUI?",
    content:
      "IUI is often recommended for couples experiencing unexplained infertility, mild male factor infertility such as low sperm count or decreased sperm motility, cervical mucus problems that can hinder sperm from entering the uterus, mild endometriosis, women with ovulation problems who can ovulate with medication, and same-sex couples or single women using donor sperm.",
  },
  {
    title: "How is the IUI procedure performed ?",
    content:
      "The IUI procedure involves several steps: Ovulation Monitoring, which includes tracking the woman's ovulation cycle through ultrasound and hormone testing, Semen Preparation, which involves collecting and washing the semen sample to concentrate the healthiest sperm; and Insemination, where a thin catheter is used to insert the prepared semen directly into the uterus. This is usually a quick and painless procedure. Post-procedure, the woman may rest for a short period before resuming normal activities. A pregnancy test is typically performed two weeks later to determine the outcome.",
  },
  {
    title: "What are the success rates for IUI at the Pluro Jabalpur IVF Center?",
    content:
      "The success rates of IUI can vary depending on several factors, including the age of the woman, the underlying cause of infertility, and whether fertility medications are used. At the Pluro Jabalpur IVF Center, the success rate for women under 35 is between 15% and 25%, for women aged 35 to 40, it ranges from 10% to 15%, and for women over 40, it ranges less then 10%. On average, IUI success rates range from 15% to 20% per cycle, and multiple cycles may be recommended to increase the chances of success.",
  },
  {
    title: "Are there any risks or side effects associated with IUI ?",
    content:
      "IUI is generally considered a safe procedure with minimal risks. However, some potential risks and side effects include mild discomfort, slight cramping or spotting after the procedure, a higher chance of multiple pregnancies (twins, triplets, etc.) if fertility medications are used, a small risk of infection following the procedure, and Ovarian Hyperstimulation Syndrome (OHSS) if ovulation-inducing drugs are used, which can cause swollen and painful ovaries.",
  },
];
const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },

];
export default function IUI() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>IUI (Intrauterine Insemination) – A Simple Step Towards Parenthood</title>
        <meta name="description" content="Affordable and less invasive fertility treatment that increases your chances of conception with expert monitoring." />
        <meta name="keywords" content="IUI treatment, intrauterine insemination, fertility procedure, pregnancy help" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/IUI" />
      </Helmet>
      <Container>
        <BannerSectionStyle3
          bgUrl="/images/IUI.jpeg"
          // imgUrl="/images/about/banner_img.png"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="IUI (Intra Uterine Insemination)"
        />

        <div className="cs_iui_new_wrap">
          <div className="container">

            {/* 1. Intro Section */ }
            <div className="cs_iui_intro">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h1 className="cs_main_heading">Advanced IUI Treatments at Jabalpur Fertility Centre</h1>
                  <p>
                    Intra Uterine Insemination (IUI) is a widely used and
                    effective fertility treatment that can help many couples
                    achieve their dream of parenthood. At Jabalpur Fertility
                    Centre, the Best Fertility Clinic in Jabalpur, we offer
                    state-of-the-art IUI treatments under the expert care of Dr.
                    Archana Shrivastav, the Best IVF Doctor in Jabalpur. Our
                    goal is to provide you with personalized, compassionate care
                    and the best chances of success.
                  </p>
                </div>
                <div className="col-lg-6">
                  <div className="cs_iui_intro_box">
                    <h2>What is IUI?</h2>
                    <p>
                      Intra Uterine Insemination (IUI) is a fertility treatment
                      that involves placing specially prepared sperm directly into
                      a woman's uterus during her ovulation period. This procedure
                      increases the number of sperm that reach the fallopian
                      tubes, thereby enhancing the chances of fertilization. IUI
                      is a less invasive and less expensive option compared to
                      other assisted reproductive technologies, making it a
                      popular choice for many couples.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 2. Recommended Grid Section */ }
            <div className="cs_iui_recommended">
              <h2>When is IUI Recommended?</h2>
              <p style={ { textAlign: "center", color: "#666", marginBottom: "40px" } }>IUI may be recommended for couples facing the following fertility issues :</p>

              <div className="cs_iui_grid">
                <div className="cs_recommended_card">
                  <div className="cs_rc_icon">01</div>
                  <div className="cs_rc_title">Unexplained Infertility</div>
                  <p className="cs_rc_desc">When no specific cause of infertility is identified after a complete fertility workup.</p>
                </div>

                <div className="cs_recommended_card">
                  <div className="cs_rc_icon">02</div>
                  <div className="cs_rc_title">Mild Male Factor Infertility</div>
                  <p className="cs_rc_desc">Including issues such as low sperm count, poor motility, or abnormal sperm morphology.</p>
                </div>

                <div className="cs_recommended_card">
                  <div className="cs_rc_icon">03</div>
                  <div className="cs_rc_title">Cervical Factor Infertility</div>
                  <p className="cs_rc_desc">When cervical mucus is hostile to sperm, preventing it from entering the uterus.</p>
                </div>

                <div className="cs_recommended_card">
                  <div className="cs_rc_icon">04</div>
                  <div className="cs_rc_title">Ovulation Disorders</div>
                  <p className="cs_rc_desc">Including irregular or absent ovulation.</p>
                </div>

                <div className="cs_recommended_card">
                  <div className="cs_rc_icon">05</div>
                  <div className="cs_rc_title">Endometriosis</div>
                  <p className="cs_rc_desc">Mild to moderate cases where other treatments have not been successful.</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Start FAQ Section */ }
        <div className="cs_iui_timeline_section">
          <Section
            topMd={ 60 }
            topLg={ 40 }
            topXl={ 20 }
            bottomMd={ 20 }
            bottomLg={ 15 }
            bottomXl={ 11 }
          >
            <WorkingProcess
              sectionTitle="How IUI Works"
              sectionTitleUp=""
              sectionTitleDown=""
              sectionSubTitle=""
              data={ workingProcessData }
            />
          </Section>
        </div>

        {/* End FAQ Section */ }
        <div className="cs_iui_new_wrap" style={ { paddingTop: 0 } }>
          <div className="container">

            {/* 4. Success Rates Section */ }
            <div className="cs_iui_success">
              <h2>Success Rates and Factors Affecting IUI</h2>
              <p>Success rates for IUI can vary based on several factors, including :</p>

              <div className="cs_success_grid">
                <div className="cs_success_item">
                  <div className="cs_si_icon">✓</div>
                  <div className="cs_si_content">
                    <h4>Age of the Woman</h4>
                    <p>Younger women generally have higher success rates.</p>
                  </div>
                </div>

                <div className="cs_success_item">
                  <div className="cs_si_icon">✓</div>
                  <div className="cs_si_content">
                    <h4>Cause of Infertility</h4>
                    <p>Couples with unexplained infertility or mild male factor infertility tend to have better outcomes.</p>
                  </div>
                </div>

                <div className="cs_success_item">
                  <div className="cs_si_icon">✓</div>
                  <div className="cs_si_content">
                    <h4>Number of IUI Cycles</h4>
                    <p>Success rates often increase with multiple cycles.</p>
                  </div>
                </div>

                <div className="cs_success_item">
                  <div className="cs_si_icon">✓</div>
                  <div className="cs_si_content">
                    <h4>Use of Fertility Medications</h4>
                    <p>Medications to induce ovulation can enhance success rates.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 5. Why Choose Us Section */ }
            <div className="cs_iui_why_choose">
              <h2>Why Choose Jabalpur Fertility Centre for IUI?</h2>

              <div className="cs_why_list">
                <div className="cs_why_item">
                  <div className="cs_wi_icon">01</div>
                  <div className="cs_wi_content">
                    <h4>Expertise and Experience</h4>
                    <p>Led by Dr. Archana Shrivastava, our team has extensive experience in performing successful IUI procedures.</p>
                  </div>
                </div>

                <div className="cs_why_item">
                  <div className="cs_wi_icon">02</div>
                  <div className="cs_wi_content">
                    <h4>Personalized Care</h4>
                    <p>We tailor our treatment plans to meet the unique needs of each couple, ensuring the best possible outcomes.</p>
                  </div>
                </div>

                <div className="cs_why_item">
                  <div className="cs_wi_icon">03</div>
                  <div className="cs_wi_content">
                    <h4>Comprehensive Fertility Services</h4>
                    <p>From initial consultation and complete fertility workup to advanced treatments like IVF and IUI, we offer a full spectrum of fertility services.</p>
                  </div>
                </div>

                <div className="cs_why_item">
                  <div className="cs_wi_icon">04</div>
                  <div className="cs_wi_content">
                    <h4>State-of-the-Art Facility</h4>
                    <p>Our clinic is equipped with the latest technology and facilities to provide top-notch fertility care.</p>
                  </div>
                </div>

                <div className="cs_why_item" style={ { gridColumn: "1 / -1", maxWidth: "600px", margin: "0 auto" } }>
                  <div className="cs_wi_icon">05</div>
                  <div className="cs_wi_content">
                    <h4>Patient-Centered Approach</h4>
                    <p>We prioritize your comfort and well-being, offering compassionate support throughout your fertility journey.</p>
                  </div>
                </div>
              </div>
            </div>

            <Section topMd={ 40 } topLg={ 30 } topXl={ 20 }>
              <div className="cs_iui_faq_wrapper">
                <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
              </div>
            </Section>

            {/* 6. Contact Us Section */ }
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px', marginTop: '80px', marginBottom: '80px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering IUI as a fertility treatment option,
                  contact Jabalpur Fertility Centre today. Our expert team is
                  here to guide you through the process and help you achieve
                  your dream of starting a family.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>

          </div>
        </div>

        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const Container = styled.div`
  .margin {
    margin-left: 25px;
  }
   .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
`;
